import { random } from 'lodash';
import React, { FC, useMemo } from 'react';
import Placeholder from './Placeholder';
import * as styles from './PlaceholderParagraph.module.scss';

interface PlaceholderParagraphProps {
  words?: number;
}

const PlaceholderParagraph: FC<PlaceholderParagraphProps> = ({ words = 10 }) => {
  const sizes = useMemo(() => Array.from(Array(words)).map(() => random(1, 5) * 16), [words]);

  return (
    <>
      {sizes.map(size => (
        <>
          <Placeholder className={styles.text} size={size} />
          &nbsp;
        </>
      ))}
    </>
  );
};

export default PlaceholderParagraph;
